import React from 'react';

import CountryInfo from '../CountryInfo';

const PACKAGE_SECTION = {
    title: 'Policy Package',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    Extension of SME credit guarantee (BMKB) scheme to help SMEs
                    affected by the coronavirus secure bank guarantees & bridge
                    financing.
                </li>
                <li>
                    Requirements to apply for unemployment benefit during
                    short-time working (wtv) will be easier to meet.
                </li>
                <li>
                    Self-employed professionals may apply for financial support
                    for self-employed professionals (Bbz).
                </li>
                <li>
                    Special payment extension for for income tax, corporate
                    income tax, turnover tax and payroll tax.
                </li>
                <li>Reduction of provisionary assessment.</li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Netherlands: The coronavirus and your company: a roadmap',
            url: 'https://business.gov.nl/the-coronavirus-and-your-company/#article-measures-announced-by-the-government',
        },
        {
            title: 'SME credit guarantee scheme (BMKB)',
            url: 'https://business.gov.nl/subsidy/bmkb/',
        },
        {
            title: 'Application for SME Loan Guarantee (BMKB) to one of the participating banks or other funders',
            url: 'https://www.rvo.nl/subsidie-en-financieringswijzer/borgstelling-mkb-kredieten-bmkb/deelnemen-als-financier',
        },
        {
            title: 'Information for application for financial support for self-employed professionals (Bbz)',
            url: 'https://www.rvo.nl/subsidie-en-financieringswijzer/borgstelling-mkb-kredieten-bmkb/deelnemen-als-financier',
        },
        {
            title: 'Tax payment defferal for entrepreneurs in special circumstances',
            url: 'https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/zakelijk/aangifte_betalen_en_toezicht/belasting_betalen_of_terugkrijgen/uitstel_van_betaling_voor_ondernemers_met_betalingsproblemen/uitstel_van_betaling_bij_bijzondere_omstandigheden/',
        },
    ],
};

const OTHER_SECTION = {
    title: 'Other Financial Relief',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>Emergency Fund Bridging Employment</li>
                <li>Temporary provision of income support for freelancers</li>
                <li>Broadening BMKB</li>
                <li>Tax deferral</li>
                <li>
                    Broadening of the Guarantee scheme for entrepreneurial
                    financing
                </li>
                <li>
                    Interest rebate for small entrepreneurs on microcredits
                    Qredits
                </li>
                <li>Affected sectors compensation scheme</li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Het coronavirus: check hier je regelingen',
            url: 'https://www.kvk.nl/corona/het-coronavirus-check-hier-je-regelingen/#voorgenomen',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Netherlands',
    lastUpdated: 'March 27, 2020',
    introSection: (
        <p>
            <strong>
                The Dutch Government has put together a comprehensive FAQ for
                entrepreneurs impacted by Covid-19:
            </strong>
            <br />
            <a
                href="https://www.kvk.nl/corona/veelgestelde-ondernemersvragen-over-corona/"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Veelgestelde ondernemers­vragen over corona
            </a>
            .
        </p>
    ),
    sections: [PACKAGE_SECTION, OTHER_SECTION],
};

const NetherlandsInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default NetherlandsInfo;
